module.exports = __webpack_public_path__ + "static/assets/5293b3bebc31f32ac084c5a193131b40.svg";